import type { FormDefinition } from '@/core/templates/types'

const JC_ONLY_SECTIONS = ['Vorzeitiges Ende']
const AFA_ONLY_SECTIONS = ['Integrationschancen']

export function isJobcenter(behoerde: string | null | undefined): boolean {
  return !!behoerde && behoerde.toLowerCase().includes('jobcenter')
}

export function filterBerichtTemplate(
  template: FormDefinition,
  behoerde: string | null | undefined,
): FormDefinition {
  const drop = new Set(isJobcenter(behoerde) ? AFA_ONLY_SECTIONS : JC_ONLY_SECTIONS)
  return {
    ...template,
    sections: Object.fromEntries(Object.entries(template.sections).filter(([section]) => !drop.has(section))),
  }
}
